module.exports = __webpack_public_path__ + "static/media/line-columns.95212afc.svg";